import React from 'react'
import { TextField } from '@material-ui/core'
import './RangeInput.less'
import { useRangeInput } from './hooks/useRangeInput'

export const VALIDATION = {
    YEAR: {
        field: 'YEAR',
        regex: /^\d{1,4}$/
    },
    INTEGER: {
        field: 'INTEGER',
        regex: /^\d+$/
    }
}

export const RangeInput = ({
    from,
    to,
    name = '',
    validationType = VALIDATION.YEAR.field,
    errors = [],
    fieldInfo,
    // optional
    validateLogic = () => {},
    maskFuntions = {},
    handleChange = () => {}
}) => {
    const {
        from: fromState,
        to: toState,
        handleRange,
        error,
        handleError
    } = useRangeInput({
        fromInit: from,
        toInit: to,
        errors
    })

    const validateInput = (type, value) => {
        let response = { error: '', success: false }
        if (!value) {
            response.success = true
            return response
        }

        const regex = new RegExp(VALIDATION[type]['regex'])
        response.success = regex.test(value)
        if (type === VALIDATION.YEAR.field) {
            response.error = !response.success
                ? 'Formato de año incorrecto'
                : ''
        } else if (type === VALIDATION.INTEGER.field) {
            response.error = !response.success ? 'Formato incorrecto' : ''
        }
        return response
    }

    const handleChangeTextField = e => {
        const field = e.target.name.split('-')[0]
        let value = e.target.value
        if (typeof maskFuntions.removeMask === 'function') {
            value = maskFuntions.removeMask(value)
        }
        const { success } = validateInput(validationType, value)
        if (!success) return

        const values = {
            currentFrom: field === 'from' ? value : fromState,
            currentTo: field === 'to' ? value : toState
        }
        if (
            Boolean(values.currentFrom) &&
            typeof maskFuntions.removeMask === 'function'
        ) {
            values.currentFrom = maskFuntions.removeMask(values.currentFrom)
        }
        if (
            Boolean(values.currentTo) &&
            typeof maskFuntions.removeMask === 'function'
        ) {
            values.currentTo = maskFuntions.removeMask(values.currentTo)
        }
        validateLogic({
            currentFrom: +values.currentFrom,
            currentTo: +values.currentTo,
            showError: handleError,
            key: fieldInfo?.key
        })
        if (typeof maskFuntions.applyMask === 'function') {
            value = maskFuntions.applyMask(value)
        }
        handleRange(field, value, currentState => {
            handleChange(currentState)
        })
    }

    return (
        <div className="container-range-input form d-flex align-items-center pt-4 pb-5">
            <div className="d-flex col-2 align-items-center p-0 mr-3">
                <TextField
                    id={`from-${name}`}
                    variant="outlined"
                    label="Desde"
                    value={fromState || ''}
                    name={`from-${name}`}
                    disabled={Boolean(to)}
                    size="small"
                    onChange={handleChangeTextField}
                ></TextField>
            </div>

            <div className="input-to d-flex col-2 align-items-center p-0">
                <TextField
                    id={`to-${name}`}
                    variant="outlined"
                    label="Hasta"
                    value={toState || ''}
                    name={`to-${name}`}
                    size="small"
                    autoComplete="off"
                    onChange={handleChangeTextField}
                    error={Boolean(error)}
                    helperText={error}
                ></TextField>
            </div>
        </div>
    )
}
